import { EncryptJWT, jwtDecrypt } from 'jose';

class Crypto {
    private static readonly secret_key = new TextEncoder().encode(process.env.RT_KEY);

    public static encrypt = async (data: string) => {
        const encrypted = await new EncryptJWT({ data })
            .setProtectedHeader({ alg: 'dir', enc: 'A256GCM' })
            .setIssuedAt()
            .setExpirationTime('1m') // Set expiration time (optional)
            .encrypt(this.secret_key); // Now 'this' refers to the class, so it works

        return encrypted;
    }

    public static decrypt = async (data: string) => {
         try {
            const { payload } = await jwtDecrypt(data.toString(), this.secret_key, {
                contentEncryptionAlgorithms: ['A256GCM'],
                keyManagementAlgorithms: ['dir'],
            });
            
            return payload.data;
        } catch (error) {
            console.log(error.code)
            return { 'error':'An error occurred while processing your request.', 'message': error.code }
        }
    }
}

export default Crypto;